import { router } from "@inertiajs/react";
import type { DestinationRow, OrganizationOption } from "./types";

interface Props {
  organizations: OrganizationOption[];
  destinations: DestinationRow[];
  copy: Record<string, string>;
}

export default function OrganizationRouting({
  organizations,
  destinations,
  copy,
}: Props) {
  const enabled = destinations.filter((destination) => destination.enabled);
  const assign = (organizationId: string, destinationId: string) => {
    router.patch("/cc/forge_destinations/assign_organization", {
      organization_id: organizationId,
      destination_id: destinationId,
    });
  };

  return (
    <section className="mt-6 rounded-lg border border-border bg-card">
      <header className="border-b border-border px-4 py-3">
        <h2 className="text-sm font-semibold">{copy.organization_routing}</h2>
        <p className="mt-0.5 text-xs text-muted-foreground">
          {copy.organization_routing_description}
        </p>
      </header>
      <div className="divide-y divide-border">
        {organizations.map((organization) => (
          <label
            key={organization.id}
            className="grid items-center gap-3 px-4 py-3 sm:grid-cols-[1fr_minmax(240px,360px)]"
          >
            <span className="text-sm font-medium">{organization.name}</span>
            <select
              value={organization.default_forge_destination_id || ""}
              onChange={(event) => assign(organization.id, event.target.value)}
              className="h-9 rounded-md border border-input bg-background px-3 text-sm"
            >
              <option value="">{copy.use_global_default}</option>
              {enabled.map((destination) => (
                <option key={destination.id} value={destination.id}>
                  {destination.name}
                </option>
              ))}
            </select>
          </label>
        ))}
      </div>
    </section>
  );
}
